module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_dpp_int-couloir-fixe_final-perso.2717e20f.jpg";